
/**
 * Feature flags for controlling feature availability across the application.
 */
export const featureFlags = {
    /**
     * Controls whether the achievement system is enabled.
     * When false, achievements cannot be earned, and achievement UI is hidden.
     */
    achievementsEnabled: true,
};
